import z from 'zod';

const pendingSessionSchema = z.object({
  gameDescription: z.string(),
  gameType: z.string(),
  gameId: z.number(),
  sessionBalance: z.number(),
});

export const pendingSessionsResponseSchema = z.object({
  channel: z.number(),
  requestId: z.string(),
  updatedAt: z.number(),
  pendingSessions: z.array(pendingSessionSchema),
  totalSessionBalance: z.number(),
  token: z.string(),
});

export type PendingSession = z.infer<typeof pendingSessionSchema>;

export type PendingSessionsResponse = z.infer<
  typeof pendingSessionsResponseSchema
>;
